import { FC } from 'react'
import styles from 'components/features/pfm/StackedChart/StackedChart.styl'
import { getBreakdownBounds } from 'components/features/future/helpers'
import { cssVar } from 'helpers/styleHelpers'
import { BreakdownDate } from 'components/features/pfm/StackedChart/BreakdownDate'
import { NetworthBreakdownDate } from 'components/features/future/types'
import cn from 'classnames'

type StackedChartProps = {
  items: NetworthBreakdownDate[]
  width: number
  height: number
  highlightIndex: number
}

export const StackedChart: FC<StackedChartProps> = (props) => {
  const {
    items,
    width,
    height,
    highlightIndex,
  } = props

  const barWidth = width / 2 / items.length
  const vertBounds = getBreakdownBounds(items)
  const ratio = height / (vertBounds.positive - vertBounds.negative)
  const zeroOffset = (vertBounds.positive * ratio) || height / 2

  const itemsChild = items.map((item, index) => (
    <div key={ index } className={ cn(styles.item, highlightIndex !== -1 && highlightIndex !== index && styles.lolight) }>
      <BreakdownDate item={ item } ratio={ ratio } />
    </div>
  ))

  return (
    <div
      className={ styles.axis }
      style={ cssVar({
        '--zero-offset': `${ zeroOffset }px`,
        '--bar-width': `${ barWidth }px`,
      }) }
    >
      { itemsChild }
    </div>
  )
}
